export default {
  placeholder: "Bitte eingeben...",
  "placeholder.search": "Suchen...",
  "smart-search.placeholder": "Was möchten Sie tun?",
  "enter-password.placeholder": "Passwort eingeben...",
  "reason-for-cancellation.placeholder": "Stornierungsgrund eingeben...",
  "signup.date-of-birth.placeholder": "Datum auswählen",
  "signup.phone.pre-dial.placeholder": "+49",
  "signup.phone.number.placeholder": "12345678",
  "placeholder.select": "Bitte auswählen...",
  "placeholder.start-date": "Start Datum",
  "placeholder.end-date": "End Datum",
};
